"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../icons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ErrorHolder = _styledComponents["default"].div.attrs(function () {
  return {
    name: "error-holder"
  };
}).withConfig({
  displayName: "ErrorMessage__ErrorHolder",
  componentId: "r7jqwb-0"
})(["color:", ";"], function (props) {
  return props.theme["mlb-red"];
});

var ErrorIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "ErrorMessage__ErrorIcon",
  componentId: "r7jqwb-1"
})(["&&&{color:", ";&:hover{", ";}}"], function (props) {
  return props.theme["mlb-red"];
}, function (props) {
  return props.theme["mlb-red"];
});

var ErrorMessage = function ErrorMessage(_ref) {
  var children = _ref.children;
  return _react["default"].createElement(ErrorHolder, null, _react["default"].createElement(ErrorIcon, {
    iconName: "fa-exclamation-triangle",
    className: "mr-2"
  }), children);
};

ErrorMessage.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = ErrorMessage;
exports["default"] = _default;